import { render, staticRenderFns } from "./StaffDashboardView.vue?vue&type=template&id=0482c274&scoped=true"
import script from "./StaffDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffDashboardView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StaffDashboardView.vue?vue&type=style&index=0&id=0482c274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482c274",
  null
  
)

export default component.exports